// Sentry error tracking - stub implementation
// Sentry package is not installed, so we provide no-op functions

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!SENTRY_DSN) {
    console.log("[Sentry] DSN not configured, skipping initialization");
    return;
  }
  console.log("[Sentry] Package not installed, skipping initialization");
}

export function captureException(error: Error, context?: Record<string, any>) {
  // No-op - Sentry not installed
}

export function setUser(user: { id: string; email?: string; role?: string } | null) {
  // No-op - Sentry not installed
}

export function addBreadcrumb(
  message: string,
  category: string,
  level: "info" | "warning" | "error" = "info"
) {
  // No-op - Sentry not installed
}

export const Sentry = {
  captureException,
  setUser,
  addBreadcrumb,
  init: initSentry,
  withScope: (callback: (scope: any) => void) => {
    // No-op
  },
};
